import React from 'react';
import Hero from '../../components/home/Hero/Hero';
import TrendingNews from '../../components/home/TrendingNews/TrendingNews';
import TellYourStory from '../../components/home/TellYourStory/TellYourStory';
import NewsStartups from '../../components/home/NewsStartups/NewsStartups';
import Recognition from '../../components/home/Recognition/Recognition';
import WomenEmpowerment from '../../components/home/WomenEmpowerment/WomenEmpowerment';
import Farming from '../../components/home/Farming/Farming';
import Innovation from '../../components/home/Innovation/Innovation';
import FeaturedNews from '../../components/home/FeaturedNews/FeaturedNews';
import Unicorn from '../../components/home/Unicorn/Unicorn';
import Technology from '../../components/home/Technology/Technology';
import Subscribe from '../../components/home/Subscribe/Subscribe'; 
import styles from './Home.module.css';

const Home: React.FC = () => {
  return (
    <div className={styles.homePage}>
      <Hero />
      <FeaturedNews />
      <TrendingNews />
      <NewsStartups />
      <Technology />
      <Unicorn />
      <Recognition />
      <Innovation />
      <WomenEmpowerment />
      <Farming />

      <TellYourStory />

      <Subscribe />
    </div>
  );
};

export default Home;